<template>
    <div class="login">
        <div class="login__bg"></div>
        <div class="container container--large container--no-padding-mobile">
            <div class="login__row">
                <div class="login__content">

                    <div class="login__header">
                        <div class="login__wrapper">
                            <nav class="login__nav">
                                <router-link :to="{ name: 'Login'}" class="login__nav__link" :class="{'is-active': mode === 'login'}"><translate>login</translate></router-link>
                                <router-link :to="{ name: 'Register'}" class="login__nav__link" :class="{'is-active': mode === 'register'}"><translate>sign_up</translate></router-link>
                            </nav>
                        </div>
                    </div>

                    <div class="login__social">
                        <div class="login__wrapper">
                            <puma-button class="login__button button--border" @click="loginWithFacebookLocal" :loading="facebookLoading">
                                <Icon :name="'facebook'" class="login__button__icon"></Icon>
                                <span v-if="mode === 'login'"><translate>login_with_facebook</translate></span>
                                <span v-if="mode === 'register'"><translate>sign_in_with_facebook</translate></span>
                            </puma-button>
                            <!-- <puma-button class="login__button button--border" @click="loginWithTwitterLocal" :loading="twitterLoading">
                                <Icon :name="'twitter'" class="login__button__icon"></Icon>
                                <span><translate>sign_in_with_twitter</translate></span>
                            </puma-button> -->
                            
                            <!-- TODO : puma button component didnt work for this link -->
                            <a class="button login__button button--border" href="https://api.pumatr.ac/oauth/twitter" @click.prevent="twitterButtonClick('https://api.pumatr.ac/oauth/twitter')">
                                <Icon :name="'twitter'" class="login__button__icon"></Icon>
                                <span v-if="mode === 'login'"><translate>login_with_twitter</translate></span>
                                <span v-if="mode === 'register'"><translate>sign_in_with_twitter</translate></span>
                            </a>

                            <puma-button class="login__button button--border" @click="loginWithAppleLocal" :loading="appleLoading">
                                <Icon :name="'apple'" class="login__button__icon"></Icon>
                                <span v-if="mode === 'login'"><translate>login_with_apple</translate></span>
                                <span v-if="mode === 'register'"><translate>sign_in_with_apple</translate></span>
                            </puma-button>

                            <div class="form__error" v-if="socialError">{{ socialError }}</div>
                        </div>
                    </div>

                    <div class="login__separator">
                        <div class="login__separator__text">
                            <span v-if="mode === 'login'" v-translate>or_login_with_email</span>
                            <span v-if="mode === 'register'" v-translate>or_sign_up_with_email</span>
                        </div>
                    </div>

                    <div class="login__form" :class="mode === 'register' ? 'login__form--register': ''">
                        <div class="login__wrapper">
                            <validation-observer v-slot="{ handleSubmit }">
                                <form class="form" @submit.prevent="handleSubmit((terms && mode === 'register') || mode === 'login'  ? formSubmitHandler : errorTerms = true)" autocomplete="on">
                                    <validation-provider class="form__row" rules="required|email" v-slot="{ errors }">
                                        <div class="form__item">
                                            <input v-model="email" type="email" class="login__form__field form__field form__field--text" name="email" autocomplete="username" :placeholder="emailPlaceholder" :class="{'is-error': errors.length}"/>
                                        </div>
                                        <div class="form__error">{{ errors[0] }}</div>
                                    </validation-provider>
            
                                    <validation-provider 
                                        class="form__row" 
                                        rules="required|min:6" 
                                        vid="password" 
                                        :name="passwordPlaceholder"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form__item">
                                            <input 
                                                v-model="password" 
                                                @input="passwordChangeHandler" 
                                                :type="passwordFieldType" 
                                                class="login__form__field form__field form__field--password" 
                                                :placeholder="passwordPlaceholder" 
                                                name="password" 
                                                autocomplete="current-password"
                                                :class="{'is-error': errors.length}"
                                            />
                                            <div class="form__show-password" :class="[{'is-password-visible': passwordFieldPasswordVisible}, {'is-switch-visible': passwordFieldFilled}]" @click="() => togglePassword('original')">
                                                <span class="form__show-password__show" v-translate>show</span>
                                                <span class="form__show-password__hide" v-translate>hide</span>
                                            </div>
                                        </div>
                                        <div class="form__error">{{ errors[0] }}</div>
                                    </validation-provider>
            
                                    <validation-provider class="form__row" rules="required|confirmed:password" v-slot="{ errors }" v-if="mode === 'register'" >
                                        <div class="form__item">
                                            <input 
                                                v-model="passwordRepeat" 
                                                @input="passwordRepeatChangeHandler" 
                                                :type="passwordRepeatFieldType"
                                                class="login__form__field form__field form__field--password" 
                                                :placeholder="passwordRepeatPlaceholder" 
                                                name="passwordRepeat" 
                                                :class="{'is-error': errors.length}"
                                            />
                                            <div class="form__show-password" :class="[{'is-password-visible': passwordRepeatFieldPasswordVisible}, {'is-switch-visible': passwordRepeatFieldFilled}]" @click="() => togglePassword('repeat')">
                                                <span class="form__show-password__show" v-translate>show</span>
                                                <span class="form__show-password__hide" v-translate>hide</span>
                                            </div>
                                        </div>
                                        <div class="form__error">{{ errors[0] }}</div>
                                    </validation-provider>

                                    <router-link :to="{ name: 'ForgotPassword' }" class="login__password-link" v-if="mode === 'login'"><translate>forgot_password</translate></router-link>
                                    <puma-button class="login__form__submit login__button button--border" type="submit" :loading="submitButtonLoading">
                                        <span v-translate v-if="mode === 'login'">login</span>
                                        <span v-translate v-if="mode === 'register'">sign_up</span>
                                    </puma-button>
                                    <div class="form__error" v-if="regularError">{{ regularError }}</div>
                                    

                                    <div class="login__notice" v-if="mode === 'register'">
                                        <div>
                                            <div class="form__row">
                                                <div class="form__field--checkbox">
                                                    <input type="checkbox" v-model="terms" @change="acceptTerms()">
                                                    <label v-translate>privacy_notice</label>
                                                </div>
                                                <div class="form__error" v-if="errorTerms" v-translate>terms_error</div>
                                            </div>
                                            <div class="form__row">
                                                <div class="form__field--checkbox">
                                                    <input class="checkbox" id="advertisment" type="checkbox" v-model="consents.retargeting">
                                                    <label for="advertisment" v-translate>advertisment_notice</label>
                                                </div>
                                            </div>
                                            <div class="form__row">
                                                <div class="form__field--checkbox">
                                                    <input class="checkbox" id="retargeting" type="checkbox" v-model="consents.email">
                                                    <label for="retargeting" v-translate>email_retargeting</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </form>
                            </validation-observer>
                        </div>
                    </div>
                    
                    
                    <div class="login__back">
                        <router-link :to="{ name: 'Discover' }"><translate>back_to_pumatrac</translate></router-link>
                    </div>

                </div>
                <div class="login__app">
                    <div class="login__app__inner">
                        <div class="login__app__image"></div>
                        <div class="login__app__texts">
                            <div class="login__app__title h5" v-translate>login_banner_title</div>
                            <div class="login__app__intro" v-translate>login_banner_intro</div>
                            <div class="login__app__buttons">
                                <a href="https://play.google.com/store/apps/details?id=com.pumapumatrac" target="_blank" class="login__app__buttons__item login__app__buttons__item--play-store"></a>
                                <a href="https://apps.apple.com/us/app/pumatrac-training-running/id698298978" target="_blank" class="login__app__buttons__item login__app__buttons__item--appstore"></a>
                            </div>
                            <div class="login__app__note" v-translate>login_banner_note</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from "../router";
import * as api from '../api'
import { initFacebookSdk, initAppleSdk, loginWithFacebook, clearUser, storeUser, maybeSendUserToCompleteRegistration } from '../utils/authentication';

import { addTrackingObject, captureOutboundLink } from "@/utils/tracking"

export default {
    name: "Login",
    props: {
        mode: {
            type: String 
        }
    },
    data () {
        return {
            email: '',
            password: '',
            passwordFieldType: 'text',
            passwordFieldPasswordVisible: false,
            passwordFieldFilled: false,
            passwordOriginalDirty: false,
            passwordRepeat: '',
            passwordRepeatFieldType: 'text',
            passwordRepeatFieldPasswordVisible: false,
            passwordRepeatFieldFilled: false,
            passwordRepeatDirty: false,
            submitButtonLoading: false,
            facebookLoading: false,
            twitterLoading: false,
            appleLoading: false,
            regularError: false,
            socialError: false,
            redirectAfterSuccess: null,
            terms: false,
            errorTerms: false,
            consents: {
                retargeting: false,
                email: false
            }
        }
    },
    computed: {
        emailPlaceholder() {
            return this.$gettext('email');
        },
        passwordPlaceholder() {
            return this.$gettext('password');
        },
        passwordRepeatPlaceholder() {
            return this.$gettext('password_repeat');
        }
    },
    created() {
        initFacebookSdk();
        initAppleSdk();
        if(this.$route.query.token){
            this.loginWithTwitterLocal(this.$route.query.token);
        }
        if(this.$route.params.redirect){
            this.redirectAfterSuccess = this.$route.params.redirect;
        }
    },
    mounted () {
        if(this.mode === 'login') {
            addTrackingObject({subSection: "login", screenName: "login"}, {type: "login", value: "web_login_page"});
        } else if(this.mode === 'register') {
            addTrackingObject({subSection: "login", screenName: "registration"}, {type: "login", value: "web_registration_page"});
        }
    },
    methods: {
        acceptTerms() {
           if(this.terms === true) {
               this.errorTerms = false
           } else if(this.terms === false) {
               this.errorTerms = true
           }
        },
        togglePassword(type) {
            if(type === 'original') {
                this.passwordFieldType = this.passwordFieldPasswordVisible ? 'password' : 'text';    
                this.passwordFieldPasswordVisible = !this.passwordFieldPasswordVisible;
                this.passwordOriginalDirty = true;
            } else if(type === 'repeat') {
                this.passwordRepeatFieldType = this.passwordRepeatFieldPasswordVisible ? 'password' : 'text';    
                this.passwordRepeatFieldPasswordVisible = !this.passwordRepeatFieldPasswordVisible;
                this.passwordRepeatDirty = true;
            }
        },
        passwordChangeHandler() {
            this.passwordPlaceholderToggle('original')
        },
        passwordRepeatChangeHandler() {
            this.passwordPlaceholderToggle('repeat')
        },
        passwordPlaceholderToggle(type) {
            let inputType = 'password';
            let fieldValue = type === 'original' ? this.password : this.passwordRepeat;
            if(!fieldValue.length) {
                inputType = 'text'
                if(this.passwordFieldPasswordVisible){
                    this.togglePassword(type);
                }
            }
            if(type === 'original') {
                this.passwordFieldFilled = !!fieldValue.length;
                if(!this.passwordOriginalDirty) {
                    this.passwordFieldType = inputType
                }
            } else {
                this.passwordRepeatFieldFilled = !!fieldValue.length;
                if(!this.passwordRepeatDirty) {
                    this.passwordRepeatFieldType = inputType
                }
            }
        },
        formSubmitHandler() {
            if(this.mode === 'login') {
                this.loginUser();
            } else {
                this.registerUser();
            }
        },
        
        loginWithFacebookLocal() {
            this.facebookLoading = true;
            loginWithFacebook().then((response) => {
                let userDataFromSocial = {} 
                if(response.first_name && response.last_name) {
                    userDataFromSocial.name = response.first_name + ' ' + response.last_name;
                }
                if(response.location) {
                    userDataFromSocial.location = response.location.name;
                }
                if(response.email) {
                    userDataFromSocial.email = response.email;
                }
                if(response.picture) {
                    userDataFromSocial.profileImageUrl = response.picture.data.url;
                }
                this.loginWithSocial('facebook', response.id, userDataFromSocial);
            })
        },
        async loginWithAppleLocal() {
            this.appleLoading = true;
            try {
                const response = await AppleID.auth.signIn()
                console.log('apple success', response);
                let userDataFromSocial = {} 
                if(response.user !== undefined) {
                    if(response.user.name !== undefined && response.user.name.firstName !== undefined && response.user.name.lastName !== undefined) {
                        userDataFromSocial.name = response.user.name.firstName + ' ' + response.user.name.lastName;
                    }
                    if(response.user.email) {
                        userDataFromSocial.email = response.user.email;
                    }
                }
                if(!response.authorization || !response.authorization.id_token) {
                    error.log('No authorization object');
                    this.appleLoading = false;
                    return false;
                }

                var base64Url = response.authorization.id_token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                var token = JSON.parse(jsonPayload);

                this.loginWithSocial('apple', token.sub, userDataFromSocial);
            } catch ( error ) {
                console.log('apple error', error);
                this.appleLoading = false;
                    //handle error.
            }
        },
        async loginWithTwitterLocal(tok) {

            var base64Url = tok.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            var token = JSON.parse(jsonPayload);
            token = token.authentication_token.split("").reverse().join("");;

            clearUser();
            storeUser({authToken: token});

            this.twitterLoading = true;
            
            try {
                const userResponse = await api.users.me();
                const userResponseData = userResponse.data.data;
                userResponseData.socialLogin = 'twitter';
                storeUser(userResponseData)
                this.loginSuccess();
            } catch (error) {
                console.error(error);
                console.log(error.response);
                this.twitterLoading = false;
                if(error.response.status === 401) {
                    this.regularError = this.$gettext('form_error_wrong_credentials');
                }
            } finally {
                this.twitterLoading = false;
            }
        },
        async loginUser() {
            this.submitButtonLoading = true;
            const data = {
                email: this.email,
                password: this.password,
            }
            try {
                const loginResponse = await api.users.login(data);
                const loginResponseData = loginResponse.data.data;
                clearUser();
                storeUser(loginResponseData);
                const profileResponse = await api.users.me();
                const profileResponseData = profileResponse.data.data;
                storeUser(profileResponseData);
                this.loginSuccess();

                // tracking
                addTrackingObject({subSection: "login", screenName: "login"}, {type: "login", value: "web_login_email"});
            } catch (error) {
                console.error(error);
                console.log(error.response);
                if(error.response.status === 401) {
                    this.regularError = this.$gettext('form_error_wrong_credentials');
                }
            } finally {
                this.submitButtonLoading = false;
            }
        },
        async registerUser() {
            if(this.terms === false) {
                this.errorTerms = true;
                return;
            } else {
                this.errorTerms = false;
            }
            const data = {
                email: this.email,
                password: this.password,
                consents: this.consents
            }
            try {
                const response = await api.users.register(data);
                const responseData = response.data.data;
                clearUser();
                storeUser(responseData);
                this.registrationSuccess();

                // tracking
                addTrackingObject({subSection: "login", screenName: "registration"}, {type: "registration", value: "web_registration_email"});
            } catch (error) {
                console.log(error.response);
                let errorMessageSet = false;
                if(error.response.status === 422) {
                    if(error.response.data && error.response.data.errors) {
                        if(error.response.data.errors.email && error.response.data.errors.email[0].error === 'taken') {
                            this.regularError = this.$gettext('form_error_cant_create_user_email_taken');
                            errorMessageSet = true;
                        }
                    }
                    if(!errorMessageSet) {
                        this.regularError = this.$gettext('form_error_cant_create_user');
                    }
                }
            } finally {
                this.submitButtonLoading = false;
            }
        },
        async loginWithSocial(provider, providerId, userDataFromSocial = null) {
            let data = {
                provider,
                providerId
            }
            if(userDataFromSocial && userDataFromSocial.email !== undefined) {
                data.email = userDataFromSocial.email;
            }
            try {
                const response = await api.users.register(data);
                let responseData = response.data.data;
                clearUser();
                
                if (response.status === 201 && userDataFromSocial) {
                    responseData = {...responseData, ...userDataFromSocial};
                }
                responseData.socialLogin = provider;
                console.log('store merged user with social data', responseData);
                
                storeUser(responseData);
                if(response.status === 200) {
                    // tracking
                    addTrackingObject({subSection: "login", screenName: "login"}, {type: "login", value: `web_login_${provider}`});

                    this.loginSuccess();
                } else if (response.status === 201) {
                    // tracking
                    addTrackingObject({subSection: "login", screenName: "registration"}, {type: "registration", value: `web_registration_${provider}`});

                    this.registrationSuccess();
                }
            } catch (error) {
                console.error(error);
                console.log(error.response);
                if(error.response.status === 422) {
                    this.socialLoginError = this.$gettext('form_error_cant_create_user_social');
                }
            } finally {
                this.facebookLoading = false;
                this.appleLoading = false;
                this.twitterLoading = false;
            }
        },
        loginSuccess() {
            if(this.redirectAfterSuccess){
                this.$router.push({path: this.redirectAfterSuccess})
            } else {
                this.$router.push({name: 'Discover'})
            }
            setTimeout(() => {
                maybeSendUserToCompleteRegistration();
            }, 1);
        },
        registrationSuccess() {
            this.$router.push({name: 'RegistrationSteps', params: {step: 2}})
        },
        twitterButtonClick(url) {
            const trackingName = this.mode === 'register' ? 'registration' : 'login'
            captureOutboundLink(url, {navigation: {subSection: "login", screenName: trackingName}, event: {type: trackingName, value: `web_${trackingName}_twitter`}})
        }
    }
}
</script>

<style scoped lang="scss">
.login {
    $block: &;
    min-height: calc(#{$fullheight} - #{$nav-height-mobile});
    display: flex;
    justify-content: center;
    position: relative;
    @include mq(tablet) {
        align-items: center;
        min-height: calc(#{$fullheight} - #{$nav-height-desktop});
    }
    &__bg {
        @include fillout;
        background-size: cover;
        background-position: center;
        background-image: url('../assets/img/bg-download.jpg');
        @include mq($until: tablet) {
            display: none;
        }
    }

    &__row {
        @include mq(tablet) {
            padding: 40px 0;
        }
        @include mq(tablet-landscape) {
            display: flex;
        }
    }

    &__content {
        background-color: white;
        position: relative;
        z-index: 1;
        min-height: 100%;
        flex-grow: 1;
    }

    &__wrapper {
        width: 100%;
        max-width: 410px;
        margin: 0 auto;
        padding: 0 20px;
    }

    &__header {
        border-bottom: 1px solid rgba(#000, 0.1);
    }

    &__nav {
        display: flex;
        &__link {
            flex-shrink: 0;
            flex-grow: 1;
            font-weight: $font-weight-bold;
            color: $puma-color-black;
            text-align: center;
            position: relative;
            padding: 2.5em 1em 0.75em;
            text-transform: uppercase;
            cursor: pointer;
            &:hover {
                &::after {
                    transform: none;
                }
            }
            &.is-active {
                pointer-events: none;
                &::after {
                    transform: none;
                    background-color: $puma-color-black;
                }
            }
            &::after {
                content: '';
                transition:  0.2s;
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: $puma-color-neutral-20;
                transform: scaleY(0);
                transform-origin: bottom center;
            }
        }
    }

    &__social {
        padding: 40px 0 30px;
        @include mq(tablet) {
        padding: 60px 0 46px;
        }
    }

    &__button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0;
        }
        &__icon {
            margin-right: 12px;
        }
    }
    &__separator {
        position: relative;
        display: flex;
        justify-content: center;
        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            background-color: rgba(#000, 0.1);
        }
        &__text {
            background-color: white;
            padding: 0 2em;
            font-size: $puma-size-font-md;
            position: relative;
            z-index: 1;
            @include mq(tablet) {
                font-size: $puma-size-font-lg;
            }
        }
    }
    &__form {
        padding: 30px 0 30px;
        @include mq(tablet) {
            padding: 40px 0 44px;
        }
        &__submit {
            margin-top: 24px;
            font-size: $puma-size-font-md;
        }

        &--register {
            @include mq(tablet) {
                padding: 40px 0 20px;
            }
        }
    }
    &__password-link {
        text-decoration: underline;
    }

    &__notice {
        text-align: center;
        // padding: 0 40px 30px;
        padding: 20px 0 30px;
        font-size: $puma-size-font-sm;
        a {
            text-decoration: underline;
        }
    }

    &__back {
        width: 100%;
        text-align: center;
        padding-bottom: 20px;

        a {
            position: relative;
            font-size: $puma-size-font-xs;
            display: inline-block;
            padding-bottom: 5px;

            &:after {
                content: '';
                position: absolute;
                bottom: 3px;
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
                height: 1px;
                background: black;
                transition: all .15s ease;
            }

            &:hover {
                &:after {
                    width: 10%;
                }
            }
        }
    }

    &__app {
        width: 100%;
        background-color: $puma-color-black;
        margin-top: 12px;
        flex-shrink: 0;
        position: relative;
        z-index: 2;
        padding: 30px 40px;
        color: white;
        min-height: 100%;
            align-items: center;

        display: flex;

        @include mq(tablet-landscape) {
            margin-left: 12px;
            margin-top: 0;
            max-width: 340px;
        }
        &__inner {
            width: 100%;
            text-align: center;
            @include mq($from: mobile-landscape, $until: tablet-landscape) {
                text-align: left;
                display: flex;
                align-items: center;
            }
            @include mq($from: mobile-landscape, $until: tablet) {
                align-items: flex-start;
            }
        }
        &__image {
            position: relative;
            background: url('../assets/img/app-phone-watch-screen.png') center no-repeat;
            background-size: contain;
            margin-bottom: 20px;
            @include mq($from: mobile-landscape, $until: tablet-landscape) {
                width: 33%;
                margin-bottom: 0;
            }
            @include mq($from: mobile-landscape, $until: tablet) {
                width: 50%;
            }
            &::after {
                content: '';
                position: relative;
                padding-bottom: 85%;
                display: block;
            }
        }

        &__texts {
            @include mq($from: mobile-landscape, $until: tablet-landscape) {
                max-width: 400px;
            }
        }
        &__title {
            margin-bottom: 0.5em;
        }
        &__intro {
            margin-bottom: 30px;
        }
        &__note {
            font-size: $puma-size-font-sm;
            @include mq(tablet-landscape) {
                padding: 0 2em;
            }
        }
        &__buttons {
            display: flex;
            margin-bottom: 20px;
            @include mq($from: mobile-landscape, $until: tablet-landscape) {
                max-width: 300px;
            }
            &__item {
                position: relative;
                width: 50%;
                margin-right: 12px;
                flex-grow: 1;
                border: 1px solid rgba(white, 0.5);
                border-radius: 5px;
                &:last-child {
                    margin-right: 0;
                }
                &::after {
                    content: '';
                    display: block;
                    padding-bottom: 30%;
                }
                &--appstore {
                    background-image: url('../assets/img/appstore.svg');
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
                &--play-store {
                    background-image: url('../assets/img/play-store.svg');
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
        }
    }
}
</style>